/** biome-ignore-all lint/performance/noImgElement: We need to use img elements here for the credit card icons because we're importing SVGs */

import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

import amex from '~/assets/credit-card-american-express.svg';
import mc from '~/assets/credit-card-master-card.svg';
import visa from '~/assets/credit-card-visa.svg';
import { normalizeCreditCardBrand } from '~/utils/CheckoutUtils';

export type CreditCardIconProps = Pick<ComponentProps<'img'>, 'className'> & {
  brand: string;
};

export const CreditCardIcon = memo(({ brand, className }: CreditCardIconProps) => {
  switch (normalizeCreditCardBrand(brand)) {
    case 'Visa':
      return <img alt="Visa" className={cn('size-4', className)} src={visa} />;
    case 'MasterCard':
      return <img alt="MasterCard" className={cn('size-4', className)} src={mc} />;
    case 'American Express':
      return <img alt="American Express" className={cn('size-4', className)} src={amex} />;
    default:
      return null;
  }
});

CreditCardIcon.displayName = 'CreditCardIcon';
